export default {
  back: 'TILBAKE',
  did_you_know: 'Visste du at?',
  main_goal: 'Hovedmål',
  why_relevant: 'Hvorfor er dette relevant?',
  learn_more_un: 'Learn more on the UN webpage',
  new: 'new',
  actions_matter: 'Dine handlinger betyr noe',
  useful: 'Was this infomation useful?',
  learn_more: 'lær mer',
  tag_categories: {
    categories: 'Kategorier',
    sdgs: 'Bærekraftsmålene',
  },
  tutorial: {
    name: 'Gjennomgangen',
  },
  all: {
    name: 'Alle',
  },
  habits: {
    name: 'Vaner',
  },
  popular: {
    name: 'Populære',
  },
  sustainable_food: {
    name: 'Bærekraftig mat',
    header: 'Bærekraftig mat',
    title: 'Hvorfor er bærekraftig mat viktig?',
    didYouKnow: {
      food_matters: {
        title: 'Maten vår betyr noe.',
        text: 'For helsa vår, sosialt, kulturelt og ikke minst for jorda vi lever på. De fleste av oss handler maten vår på butikken, uten å nødvendigvis legge alt for mye tanke i hva som ligger bak av ressurser, innsats og reiserute på veien til tallerkenene våre.',
        secondary_info: {
          title: 'Maten vår betyr noe.',
          text: `MARKDOWN:
Matvalgene våre i hverdagen er noe av det som har størst betydning for klima og miljø. Landbruket står for omtrent 70 prosent av verdens vannforbruk. Mer enn en tredel av alt landareal i verden brukes til matproduksjon. Og jordbruket står for ca 30% av de globale menneskeskapte klimagassutslippene. I tillegg bidrar bl.a. den høye andelen kjøtt og soyafôret laks i kostholdet vårt til ineffektiv og usolidarisk beslagleggelse av landområder, og truer dyreliv og biomangfold. Av den maten som produseres for mennesker i verden i dag, ender også en tredjedel opp som matsvinn. I 2050 anslår FN at vi vil være nærmere 10 milliarder mennesker på jorda, og at behovet for mat da vil være 60% høyere enn det er i dag. Da må vi produsere og utnytte maten vår smartere.

Da er det godt at mye går riktig vei! Og at hver av oss kan bidra mye. Å spise mer plantebasert og variert, kaste mindre mat og etterspørre etiske matvarer er noe av det hver av oss kan gjøre for et mer bærekraftig kosthold. I tillegg kan vi påvirke de rundt oss ved å dele tips og snakke om fordelene mer bærekraftige matvalg kan ha for helsa, lommeboka og miljøet.

Utvalget av vegetarmat og mer etiske matvarer har økt de siste årene. Det samme har initiativer for mindre matsvinn og inspirasjonssider for miljøvennlig mat. Å få litt mer bærekraftige matvaner trenger derfor ikke å kreve så mye. Stadig flere sier også at de ønsker å spise mer bærekraftig, og ved å velge eller etterspørre bærekraftig mat gir vi også matindustrien og politikerne beskjed om at miljø og etikk er viktig for oss.

Sammen kan hver av oss bidra til et sunt, solidarisk og bærekraftig matsystem.`,
        },
      },
    },
    description: `MARKDOWN:
###Hvorfor er bærekraftig mat viktig?
Maten vår betyr noe. For helsa vår, sosialt, kulturelt og ikke minst for jorda vi lever på. De fleste av oss handler maten vår på butikken, uten å nødvendigvis legge alt for mye tanke i hva som ligger bak av ressurser, innsats og reiserute på veien til tallerkenene våre.

Men matvalgene våre i hverdagen er noe av det som har størst betydning for klima og miljø. Landbruket står for omtrent 70 prosent av verdens vannforbruk. Mer enn en tredel av alt landareal i verden brukes til matproduksjon. Og jordbruket står for ca 30% av de globale menneskeskapte klimagassutslippene. I tillegg bidrar bl.a. den høye andelen kjøtt og soyafôret laks i kostholdet vårt til ineffektiv og usolidarisk beslagleggelse av landområder, og truer dyreliv og biomangfold. Av den maten som produseres for mennesker i verden i dag, ender også en tredjedel opp som matsvinn. I 2050 anslår FN at vi vil være nærmere 10 milliarder mennesker på jorda, og at behovet for mat da vil være 60% høyere enn det er i dag. Da må vi produsere og utnytte maten vår smartere.

Da er det godt at mye går riktig vei! Og at hver av oss kan bidra mye. Å spise mer plantebasert og variert, kaste mindre mat og etterspørre etiske matvarer er noe av det hver av oss kan gjøre for et mer bærekraftig kosthold. I tillegg kan vi påvirke de rundt oss ved å dele tips og snakke om fordelene mer bærekraftige matvalg kan ha for helsa, lommeboka og miljøet.

Utvalget av vegetarmat og mer etiske matvarer har økt de siste årene. Det samme har initiativer for mindre matsvinn og inspirasjonssider for miljøvennlig mat. Å få litt mer bærekraftige matvaner trenger derfor ikke å kreve så mye. Stadig flere sier også at de ønsker å spise mer bærekraftig, og ved å velge eller etterspørre bærekraftig mat gir vi også matindustrien og politikerne beskjed om at miljø og etikk er viktig for oss.

Sammen kan hver av oss bidra til et sunt, solidarisk og bærekraftig matsystem.`,
  },
  plastic: {
    name: 'Plast',
    header: 'Plast',
    title: 'Hvorfor er plast viktig?',
    stat: {
      title: '9%',
      description:
        'av alt plastavfall som noen gang er produsert har blitt resirkulert',
    },
    didYouKnow: {
      disappearing_plastic: {
        title:
          'Plasten forsvinner ikke fra naturen, selv når den ikke lenger er synlig.',
        secondary_info: {
          title:
            'Plasten forsvinner ikke fra naturen, selv når den ikke lenger er synlig.',
          text: `MARKDOWN:
Plast er et relativt nytt produkt i menneskets historie. Vi vet derfor lite om hva som skjer med plasten over lang tid. Men det er mye forskning som viser at plast stort sett blir i naturen veldig lenge - kanskje evig?

Den brytes opp til mindre og mindre biter fra såkalt “makroplast” til “mikroplast” og til slutt til “nanoplast”. 

Mikroplast er plastbiter på mellom 1 mikrometer til 5 millimeter - nanoplast er enda mindre.`,
        },
      },
      microplastics: {
        title: 'Mikroplast kan til slutt havne i maten du spiser.',
        secondary_info: {
          title: 'Mikroplast kan til slutt havne i maten du spiser.',
          text: `MARKDOWN:
Fugler og dyr er ekstra utsatt for å få i seg mikroplast. Dette fører til at mange dyr og fugler blir syke og i verste fall dør.

Mikroplasten fungerer også som en svamp som tiltrekker seg andre miljøgifter. Dermed spres miljøgifter via mikroplasten, inn i næringskjeder, økosystemer og dyr. Til slutt kan den ende opp på tallerken din hjemme.`,
        },
      },
    },
    statement: {
      avoid_plastic: {
        title: 'Dine handlinger betyr noe',
        secondary_info: {
          title: 'Dine handlinger betyr noe',
          text: `MARKDOWN:
Bildekk er den største utslippskilden til mikroplast i Norge i dag. Derfor er det et stort bidrag å la bilen stå. Ellers er det best å unngå å bruke plast der du kan. 

Du kan kjøpe produkter som ikke inneholder mikroplast og vaske klærne dine sjeldnere. Ikke minst kan du være med på å pushe politikere og næringsliv til å finne bedre alternativer og tiltak for å forhindre mikroplastutslipp.`,
        },
      },
    },
    description: `MARKDOWN:
###Hvorfor er plast viktig?
Fra den første plasten så dagens lys i 1907 til fram til i dag, har plasten vært med på å forandre livene våre. På godt og ondt. Plast-revolusjonen har derimot ikke kommet gratis. Den koster miljøet og klima mye. *Plastrevolusjonen* har blitt til *plastproblemet*.

Plastproblemet ligger ikke i plasten i seg selv. For plast er tross alt et fantastisk produkt som har bidratt til mye bra. Den har blant annet gjort husene våre sikrere og mer energieffektive, den har bidratt til enklere transport og den har gitt mange matvarer bedre holdbarhet. For å nevne noen bruksområder.

Problemet er vår tids store overforbruk i kombinasjon med fossile råvarer og manglende avfallshåndtering. Det har gjort materialet til en av vår tids største miljøproblemer.

Det er avgjørende med endringer på systemnivå for å få bukt med den store plastproblematikken. Likevel trenger vi individuelle tiltak. For det er vi som kontrollerer vårt eget forbruk. Våre valg som privatpersoner har stor betydning for både naturen og klimaet. *Vi kan alle* utgjøre en forskjell.`,
  },
  food_waste: {
    name: 'Matsvinn',
    header: 'Matsvinn',
    title: 'Hvorfor er måten vi bruker maten vår på så viktig?',
    didYouKnow: {
      food_matters: {
        title: 'Hvordan vi behandler maten vår spiller en rolle',
        text: 'En stor andel av de globale utslippene våre kommer fra forbruk av mat.',
        secondary_info: {
          title: 'Hvordan vi behandler maten vår spiller en rolle',
          text: `MARKDOWN:
Alle mennesker har heller ikke tilgang til maten de trenger for å leve fullverdige liv – både i våre egne lokalsamfunn og i den globale verden. I tillegg har mange mennesker brukt tid, omsorg og innsats på å dyrke fram og frakte maten til våre tallerkener. I 2050 anslår FN at vi vil være nærmere 10 milliarder mennesker på jorda, og at behovet for mat da vil være 60 % høyere enn det er i dag. Da må vi utnytte maten vår smartere.
    
Da er det godt vi er på riktig vei! Og at hver av oss kan bidra mye. Matsvinnet i Norge er på vei ned og mange har fått øynene opp for hvor mye maten vi redder fra søppelkassa har å si for miljø, solidaritet og vår egen tid og lommebok. Og at det ikke trenger å kreve mye av oss. Matsvinn oppstår gjennom små valg og vaner i hverdagen, som vi ofte ikke legger merke til. Ved å oppdage hva vi kaster og hvorfor, kan vi gjøre små justeringer som betyr mye for egen økonomi. Ved å dele oppdagelsene med andre, kan vi inspirere flere til å gjøre det samme. Sammen kan vi påvirke til et sunt, solidarisk og bærekraftig matsystem.`,
        },
      },
    },
    description: `MARKDOWN:
###Hvorfor er måten vi bruker maten vår på så viktig?
Hvordan vi behandler maten vår spiller en rolle, siden en stor andel av de globale utslippene våre kommer fra forbruk av mat. Alle mennesker har heller ikke tilgang til maten de trenger for å leve fullverdige liv – både i våre egne lokalsamfunn og i den globale verden. I tillegg har mange mennesker brukt tid, omsorg og innsats på å dyrke fram og frakte maten til våre tallerkener. I 2050 anslår FN at vi vil være nærmere 10 milliarder mennesker på jorda, og at behovet for mat da vil være 60 % høyere enn det er i dag. Da må vi utnytte maten vår smartere.
    
Da er det godt vi er på riktig vei! Og at hver av oss kan bidra mye. Matsvinnet i Norge er på vei ned og mange har fått øynene opp for hvor mye maten vi redder fra søppelkassa har å si for miljø, solidaritet og vår egen tid og lommebok. Og at det ikke trenger å kreve mye av oss. Matsvinn oppstår gjennom små valg og vaner i hverdagen, som vi ofte ikke legger merke til. Ved å oppdage hva vi kaster og hvorfor, kan vi gjøre små justeringer som betyr mye for egen økonomi. Ved å dele oppdagelsene med andre, kan vi inspirere flere til å gjøre det samme. Sammen kan vi påvirke til et sunt, solidarisk og bærekraftig matsystem.`,
  },
  food: {
    name: 'Mat',
    header: 'Mat',
    title: 'Hvorfor er mat viktig?',
    stat: {
      title: '17%',
      description: 'av all mat tilgjengelig for forbrukere sløses',
    },
    didYouKnow: {
      food_production: {
        title: 'Matproduksjonen på verdensbasis er ikke bærekraftig.',
        text: 'Å mate verdens befolkning er en stor utfordring. Landbruk krever store areal. Når vi konvertere et naturområde til dyrket mark, mister dyr og planter sine naturlig habitat, og dette fører til utryddelse av arter på sikt.',
      },
      eating_habits: {
        title:
          'Ved å få deg nye matvaner kan du bidra til en mer bærekraftig jordklode.',
        text: 'Ved å redusere matsvinn trenger vi å produsere mindre mat. Ved å spise plantebasert trenger vi mindre ressurser til å produsere maten.',
        secondary_info: {
          title:
            'Ved å få deg nye matvaner kan du bidra til en mer bærekraftig jordklode.',
          text: `MARKDOWN:
Ved å redusere matsvinn trenger vi å produsere mindre mat. Ved å spise plantebasert trenger vi mindre ressurser til å produsere maten.

En tommelfingerregel er at det er krever 10 kg plantefõr for å produsere 1 kg kjøtt. Hvis vi hadde brukt dette arealet til å heller lage planter som kunne blitt spist av mennesker, hadde vi ikke trengt å ødelegge så mange naturlige økosystemer for å mate menneskeheten. 

En redusert matproduksjon vil ha mange fordeler, som å spare store mengder ferskvann og landareal i tillegg til å bidra til en betydelig reduksjon i klimagassutslipp.`,
        },
      },
    },
    statement: {
      eating_habits: {
        title: 'Dine handlinger betyr noe',
        secondary_info: {
          title: 'Dine handlinger betyr noe',
          text: `MARKDOWN:
Ved å få deg nye matvaner vil du også gi et tydelig signal til både industri og politikere at du er villig til å være med på en omstilling av samfunnet. Sammen skaper vi økt etterspørsel etter bærekraftige matprodukter fra industrien og politiske reguleringer som kan tvinge alle aktører i en bærekraftig retning enda raskere.`,
        },
      },
    },
    description: `MARKDOWN:
###Hvorfor er mat viktig?
Vi har dessverre ikke en bærekraftig matproduksjon og distribusjon i dagens samfunn. En av hovedutfordringene er at matproduksjon krever enorme landarealer som igjen er en av grunnene til hvorfor en stor del av verdens dyrearter utryddes fordi vi tar fra dem deres naturlige habitater.
  
Den gode nyhetene er at du kan bidra effektivt til en mer bærekraftig planet ved å teste nye matvaner. Eksempelvis vil du ved å kaste mindre mat eller spise mer plantebasert bidra til at vi kan produsere mye mindre mat enn i dag (vi må produsere langt flere kalorier for å mate dyr enn det vi kan få tilbake i form av kjøtt eller melk). En redusert matproduksjon vil ha mange fordeler som å spare store mengder ferskvann og landareal i tillegg til å bidra til en betydelig reduksjon i klimagassutslipp. 
  
Ved å teste nye matvaner vil du også gi et tydelig signal til både industri og politikere at du er villig til å være med på en omstilling av samfunnet.  Sammen skaper vi økt etterspørsel etter bærekraftige matprodukter fra industrien og politiske reguleringer som kan tvinge alle aktører i en bærekraftig retning enda raskere.`,
  },
  transport: {
    name: 'Transport',
    header: 'Transport',
    title: 'Hvorfor er Transport viktig?',
    stat: {
      title: '50%',
      description:
        'av verdens urbane befolkning har praktisk tilgang til offentlig transport',
    },
    didYouKnow: {
      using_transport: {
        title:
          'En stor del av verdens klimagassutslipp kommer fra transportsektore. Måten vi bruker transport er derfor viktig i tiden som kommer.',
        text: 'På verdensbasis er det sterk befolkningsvekst i byer, og derfor trenger vi å redusere transportbehov for å opprettholde akseptabel luftkvalitet og redusere klimassgassutslipp i tråd med internasjonale klimamål.',
        secondary_info: {
          title:
            'En stor del av verdens klimagassutslipp kommer fra transportsektore. Måten vi bruker transport er derfor viktig i tiden som kommer.',
          text: `MARKDOWN:
På verdensbasis er det sterk befolkningsvekst i byer, og derfor trenger vi å redusere transportbehov for å opprettholde akseptabel luftkvalitet og redusere klimassgassutslipp i tråd med internasjonale klimamål. 

Ved å endre dine transportvaner, bidrar du til å gjøre miljøvennlig transport mulig. 

For det første. vil dine miljøvennlige transportvalg skape betydelig utslippsreduksjon, som igjen er viktig for å holde jordkloden beboelig for menneskeheten. 

For det andre, valg som reduserer trafikk øker luftkvaliteten lokalt, som er bra din og andres helse.

For det tredje vil du bidra til at man ikke trenger å bruke like mye plass til veier og parkeringsplasser. Slik kan  planter, dyr og insekter kan få mer plass å boltre seg.`,
        },
      },
    },
    statement: {
      politicians: {
        title: 'Dine handlinger betyr noe',
        secondary_info: {
          title: 'Dine handlinger betyr noe',
          text: `MARKDOWN:
Kanskje viktigst er det likevel at du ved å gjennomføre miljøvennlige transportvalg viser politikerne og industrien at det er en økende etterspørsel etter miljøvennlige transportalternativer, og at du er villig til å være med på en krevende og spennende omstilling.`,
        },
      },
    },
    description: `MARKDOWN:
###Hvorfor er Transport viktig?
En stor del av verdens klimagassutslipp kommer fra transportsektoren og måten vi transporterer oss vil derfor bli viktig fremover. Eksempelvis har vi en sterk befolkningsvekst spesielt i byene våre og et skifte til mer kollektivtransport er helt essensielt for å kunne beholde en akseptabel luftkvalitet og for å kunne redusere utslipp i tråd med klimamål. 

Ved å gjennomføre transportaktiviteter bidrar du til å gjøre dette skiftet til mer miljøvennlig transport mulig. For det første vil dine miljøvennlige transportvalg bidra til en betydelig utslippsreduksjon i seg selv noe som er viktig for planetens helse. For det andre vil disse valgene bidra til bedre lokal luftkvalitet og ofte trening for deg selv, som er bra for helsen til deg og andre. For det tredje vil du bidra til at man ikke trenger å bruke like mye plass til veier og parkeringsplasser noe som bidrar til at planter, dyr og insekter kan få mer plass og boltre seg i og dermed hindrer du videre utryddelse av arter vi sårt trenger i våre økosystemer. 

Kanskje viktigst er det likevel at du ved å gjennomføre miljøvennlige transportvalg viser politikerne og industrien at det er en økende etterspørsel etter miljøvennlige transportalternativer, og at du er villig til å være med på en krevende og spennende omstilling.`,
  },
  consumption: {
    name: 'Varer & Tjenester',
    header: 'Varer & Tjenester',
    title: 'Hvorfor er varer & tjenester viktig?',
    stat: {
      title: '85%',
      description:
        'av tekstiler havner på søppelfyllinger eller forbrenningsanlegg, selv om de fleste kan gjenbrukes',
    },
    didYouKnow: {
      not_buying: {
        title: 'Å kjøpe ingenting er ikke alltid bedre enn å kjøpe noe',
        text: 'Penger spares sjeldent i evig tid, så selv om du ikke kjøper noe i dag, betyr det ikke at du ikke kommer til å bruke de pengene i morgen - på noe som er verre for miljøet. ',
        secondary_info: {
          title: 'Å kjøpe ingenting er ikke alltid bedre enn å kjøpe noe',
          text: `MARKDOWN:
Å leve bærekraftig innebærer ikke bare å gjøre eller kjøpe mindre. Det handler også om hvordan du bruker de pengene du har. Penger spares sjeldent i evig tid, så selv om du ikke kjøper noe i dag, betyr det ikke at du ikke kommer til å bruke de pengene i morgen - på noe som er verre for miljøet. 

Å donere penger, eller kjøpe brukt der det er mulig, er gode alternativ til å gjøre ingenting, fordi det er eksempler på bærekraftige handlemønster. Ved å lage aktiviteter innenfor temaet forbruk av varer og tjenester, har Ducky som mål å vise deg at hver gang du bruker penger, stemmer du for det du tror på. Våre aktiviteter har som mål å hjelpe deg til å tenke aktivt rundt konsekvensene av hvordan du forbruker.`,
        },
      },
      voting: {
        title:
          'Hver gang du bruker penger stemmer du på det samfunnet du ønsker å leve i.',
        text: 'Når du eksempelvis trenger nye klær har du mange valg. Du kan velge løsninger som å reparere det du allerede eier, kjøpe brukt eller å velge plagg av høy kvalitet som varer lenge, som alle vil være gode miljøvalg.',
        secondary_info: {
          title:
            'Hver gang du bruker penger stemmer du på det samfunnet du ønsker å leve i.',
          text: `MARKDOWN:
Når du eksempelvis trenger nye klær har du mange valg. Du kan velge løsninger som å reparere det du allerede eier, kjøpe brukt eller å velge plagg av høy kvalitet, som alle vil være gode miljøvalg.

La oss anta at du bruker 2000 kroner på klær fra en klesgigant uten å tenke på miljøet. Det ville føre til utslipp i størrelsesorden 100 kgCO\u2082e som er tilsvarende å kjøre 500 km i bil. Disse store utslippene kommer av at man må dyrke bomull, drive fabrikker, transportere klær, lagre dem og selge dem.

Disse prosessene krever i tillegg enorme mengder ferskvann og bruk av store landarealer som legger press på våre fantastiske økosystemer. 

Hvis du i stedet hadde brukt pengene på å reparere gamle klær ville du hatt tilnærmet ingen negativ klimapåvirkning samtidig som du ville bidratt til å skape bærekraftige arbeidsplasser i ditt nærmiljø.`,
        },
      },
    },
    description: `MARKDOWN:
###Hvorfor er Forbruk viktig?
Vi har definert denne kategorien som forbruk av alt du bruker penger på med unntak av mat, energi og transport siden dette forbruket er dekket i sine egne kategorier. 

Hver gang du bruker penger stemmer du på det samfunnet du ønsker å leve i. Når du eksempelvis trenger nye klær har du mange valg. Du kan velge løsninger som å reparere, kjøpe brukt eller å  velge god kvalitet som alle vil være gode miljøvalg. La oss anta at du bruker 2000 kroner på klær fra en klesgigant uten å tenke på miljøet. Det ville føre til utslipp i størrelsesorden 100 Kg CO\u2082e som er tilsvarende å kjøre 500 km i bil. Disse store utslippene kommer av at man må dyrke bomull, drive fabrikker, transportere klær, lagre dem og selge dem. Disse prosessene krever i tillegg enorme mengder ferskvann og bruk av store landarealer som legger press på våre fantastiske økosystemer. Hvis du i stedet hadde brukt pengene på å reparere gamle klær ville du hatt tilnærmet ingen negativ klimapåvirkning samtidig som du ville bidratt til å skape bærekraftige arbeidsplasser i ditt nærmiljø.

Å leve bærekraftig innebærer ikke bare å gjøre eller kjøpe mindre. Det handler også om hvordan du bruker de pengene du har. Penger spares sjeldent i evig tid, så selv om du ikke kjøper noe i dag, betyr det ikke at du ikke kommer til å bruke de pengene i morgen - på noe som er verre for miljøet. Derfor er aktiviteter som å gi bort penger, eller å kjøpe det du trenger brukt, gode alternativer - de er eksempler på bærekraftig handlemønster. Ved å skape aktiviteter innenfor temaet forbruk, har Ducky som mål å vise deg at hver gang du bruker penger, stemmer du for det du tror på. Våre aktiviteter har som mål å hjelpe deg til å tenke aktivt rundt konsekvensene av hvordan du forbruker.`,
  },
  energy: {
    name: 'Energi',
    header: 'Energi',
    title: 'Hvorfor er Energi viktig?',
    stat: {
      title: '84%',
      description: 'av verdens energi kommer fortsatt fra fossilt brensel',
    },
    didYouKnow: {
      producing_electricity: {
        title:
          'Hvert år reduseres klimagassutslippene knyttet til produksjon av elektrisitet i Europa',
        text: 'Nesten 50% kutt siden 2000!',
        secondary_info: {
          title:
            'Hvert år reduseres klimagassutslippene knyttet til produksjon av elektrisitet i Europa',
          text: `MARKDOWN:
Vi er imidlertid i økende grad avhengig av elektrisitet, for eksempel for å drive elbiler. Det betyr at hvis vi ikke forbedrer effektiviteten og reduserer energiforbruket, vil etterspørselen etter elektrisitet fortsette å vokse.

Jo mer elektrisitet vi trenger, desto mer landareal og ressurser trenger vi for å bygge fremtidens vindmøller og solfarmer.`,
        },
      },
      renewable_energy: {
        title:
          'Å bygge ut ny, fornybar energiproduksjon vil ta tid og store landområder, og ha stor innvirkning på ressursbruken og biologisk mangfold',
        text: 'Det finnes derfor ingen tvil om at det viktigste og enkleste vi må gjøre først er å redusere vår energibruk.',
      },
    },
    statement: {
      save_energy: {
        title: 'Dine handlinger betyr noe',
        secondary_info: {
          title: 'Dine handlinger betyr noe',
          text: `MARKDOWN:
Når vi sparer energi ved for eksempel å dusje kortere eller ved å installere en varmepumpe viser vi politikere og industrien at vi er klare for endring. Dette vil igjen øke etterspørselen etter politikk som kan regulere energimarkedet slik at vi får renere strøm og etterspørselen etter produkter og tjenester fra industrien som gjør det enklere for oss å bruke mindre strøm.`,
        },
      },
    },
    description: `MARKDOWN:
###Hvorfor er Energi viktig?
All energiproduksjon har en påvirkning på miljøet og våre økosystemer, men det er en likevel en kjempestor forskjell på om energien er produsert av fornybar kraft eller ved hjelp av fossil energi. I sentrale deler av Europa kommer en relativt stor andel av energien fra fossile kilder noe som medfører et klimagassutslipp på ca 500 gram CO\u2082e per kWh (typisk ha på en panelovn i en time). Her i Norden har vi renere energi noe som gjør at det å bruke 1 kWh bare fører til et utslipp på ca 130 gram. Det betyr at det å ta en dusj i sentrale deler av Europa fører til ca 4 ganger så høye utslipp som i Norden.

Dette viser viktigheten av å bygge ut mer fornybar energi. Likevel vil denne utbyggingen ta tid og den vil kreve store naturinngrep som igjen bidrar til videre press på våre økosystemer. Det finnes derfor ingen tvil om at det viktigste og enkleste vi må gjøre først er å redusere vår energibruk. 

Når vi sparer energi ved for eksempel å dusje kortere eller ved å installere en varmepumpe viser vi politikere og industrien at vi er klare for endring. Dette vil igjen øke etterspørselen etter politikk som kan regulere energimarkedet slik at vi får renere strøm og etterspørselen etter produkter og tjenester fra industrien som gjør det enklere for oss å bruke mindre strøm.`,
  },
  handprint: {
    name: 'Håndavtrykk',
    header: 'Håndavtrykk',
    title: 'Hvorfor er Håndavtrykk viktig?',
    didYouKnow: {
      positive_impact: {
        title:
          'Ved å gjennomføre aktiviteter som øker ditt håndavtrykk har du mulighet til å skape en positiv påvirkning utover det å redusere ditt eget fotavtrykk.',
        secondary_info: {
          title:
            'Ved å gjennomføre aktiviteter som øker ditt håndavtrykk har du mulighet til å skape en positiv påvirkning utover det å redusere ditt eget fotavtrykk.',
          text: `MARKDOWN:
Første gang vi hørte om håndavtrykk var via Harvard* som definerte forskjellen mellom fotavtrykk og håndavtrykk som følger: 

“Fotavtrykk er den negative effektene som kreves for at en person eller organisasjon skal driftes i et år, altså den totale kostnaden for planeten av din tilstedeværelse. Ditt håndavtrykk er det motsatte, altså det positive bidraget du bringer til planeten det samme året. Hvis et fotavtrykk er det vi må ta fra planeten, er håndavtrykket det vi bevisst gir tilbake.

Som et eksempel kan du redusere ditt fotavtrykk ved for eksempel å sykle til jobb i stedet for å kjøre bil. På den andre siden kan du øke ditt håndavtrykk ved å inspirere dine kollega til å gjøre det samme ved for eksempel å invitere dem til en sykle-til-jobben konkurranse. 

Kan du se for deg en verden hvor vi alle forsøker å få et større håndavtrykk enn et fotavtrykk?`,
        },
      },
    },
    description: `MARKDOWN:
###Hvorfor er Håndavtrykk viktig?
Ved å gjennomføre aktiviteter som øker ditt håndavtrykk har du mulighet til å skape en positiv påvirkning utover det å redusere ditt eget fotavtrykk. Første gang vi hørte om håndavtrykk var via Harvard* som definerte forskjellen mellom fotavtrykk og håndavtrykk som følger: 

“Fotavtrykk er den negative effektene som kreves for at en person eller organisasjon skal driftes i et år, altså den totale kostnaden for planeten av din tilstedeværelse. Ditt håndavtrykk er det motsatte, altså det positive bidraget du bringer til planeten det samme året. Hvis et fotavtrykk er det vi må ta fra planeten, er håndavtrykket det vi bevisst gir tilbake.

Som et eksempel kan du redusere ditt fotavtrykk ved for eksempel å sykle til jobb i stedet for å kjøre bil. På den andre siden kan du øke ditt håndavtrykk ved å inspirere dine kollega til å gjøre det samme ved for eksempel å invitere dem til en sykle-til-jobben konkurranse. 

Kan du se for deg en verden hvor vi alle forsøker å få et større håndavtrykk enn et fotavtrykk? 

[*https://www.extension.harvard.edu/introducing-handprints](https://www.extension.harvard.edu/introducing-handprints)`,
  },
  overuse: {
    name: 'Overforbruk',
    header: 'Overforbruk',
    title: 'Hvorfor er overforbruk viktig?',
    didYouKnow: {
      so_much_plastic: {
        title: 'I 1950 produserte verden 2 millioner tonn plast.',
        text: 'Nå er tallet mer enn 380 millioner tonn årlig!',
        secondary_info: {
          title: 'I 1950 produserte verden 2 millioner tonn plast.',
          text: `MARKDOWN:
Denne ekstreme veksten skyldes blant annet overgangen fra gjenbruksartikler til engangsartikler. Vi har vent oss til et bruk-og-kast-samfunn som skader miljø, dyr og klima. 

Plastens største marked er emballasje, som står for mer enn 40%. Av dette er det aller meste laget for engangsbruk. Det produseres produkter som skal brukes én gang av et materiale som sies å vare evig. – Hvorfor? Årsaken er enkel: Plast har mange fantastiske egenskaper som gjør det til et attraktivt produkt. I tillegg er det ekstremt billig å produsere. I dag er det faktisk billigere å produsere plastprodukter lagd av såkalt “jomfruelig” olje, enn å bruke resirkulert plast eller andre mer miljøvennlige alternativer. 

Mye av disse endringene må skje på et strukturelt nivå, men hver gang du velger gjenbruks-alternativer i stedet for engangsplast, eller hver gang du sier “nei takk” til unødvendig bruk av plast, er du med på å skyve systemet i riktig retning.`,
        },
      },
    },
    description: `MARKDOWN:
###Hvorfor er overforbruk viktig?
I 1950 produserte verden 2 millioner tonn plast. Nå er tallet mer enn 380 millioner tonn årlig. Denne ekstreme veksten skyldes blant annet overgangen fra gjenbruksartikler til engangsartikler. Vi har vent oss til et bruk-og-kast-samfunn som skader miljø, dyr og klima. 

Plastens største marked er emballasje, som står for mer enn 40%. Av dette er det aller meste laget for engangsbruk. Det produseres produkter som skal brukes én gang av et materiale som sies å vare evig. – Hvorfor? Årsaken er enkel: Plast har mange fantastiske egenskaper som gjør det til et attraktivt produkt. I tillegg er det ekstremt billig å produsere. I dag er det faktisk billigere å produsere plastprodukter lagd av såkalt “jomfruelig” olje, enn å bruke resirkulert plast eller andre mer miljøvennlige alternativer. 

Mye av disse endringene må skje på et strukturelt nivå, men hver gang du velger gjenbruks-alternativer i stedet for engangsplast, eller hver gang du sier “nei takk” til unødvendig bruk av plast, er du med på å skyve systemet i riktig retning.`,
  },
  plastic_on_the_go: {
    name: 'Plast på avveie',
    header: 'Plast på avveie',
    title: 'Hvorfor er plast på avveie viktig?',
    didYouKnow: {
      ocean_plastic: {
        title: 'Mer enn 8 millioner tonn plast havner i havet hvert år',
        text: 'Det utgjør hele 15 tonn i minuttet!',
        secondary_info: {
          title: 'Mer enn 8 millioner tonn plast havner i havet hvert år',
          text: `MARKDOWN:
Siden plast er et produkt som er ment for å vare “evig” forsvinner den ikke. Den fortsetter å eksistere i en eller annen form og brytes ned til mindre og mindre biter - såkalt mikroplast. Det er estimert at bare 9% av plasten har blitt resirkulert. Noe har blitt brent mens det aller meste har havnet på deponier eller blitt kastet rett i naturen. 

Det aller viktigste tiltaket vi kan gjøre for å løse plastproblemet er å redusere plastforbruket. Hvis man må bruke plast, må man sørge for at avfallet blir håndtert riktig. Alltid. Hvis du ikke er fornøyd med din kommunes avfallshåndtering er det lov å si ifra!

Ellers husk å sørge for gjenbruk, reparer i stedet for å kjøpe nytt og resirkuler alt!`,
        },
      },
    },
    description: `MARKDOWN:
###Hvorfor er plast på avveie viktig?
Mer enn 8 millioner tonn plast havner i havet hvert år. Det utgjør *hele 15 tonn i minuttet!* Siden plast er et produkt som er ment for å vare “evig” forsvinner den ikke. Den fortsetter å eksistere i en eller annen form og brytes ned til mindre og mindre biter - såkalt mikroplast. Det er estimert at bare 9% av plasten har blitt resirkulert. Noe har blitt brent mens det aller meste har havnet på deponier eller blitt kastet rett i naturen. 

Det aller viktigste tiltaket vi kan gjøre for å løse plastproblemet er å redusere plastforbruket. Hvis man må bruke plast, må man sørge for at avfallet blir håndtert riktig. Alltid. Hvis du ikke er fornøyd med din kommunes avfallshåndtering er det lov å si ifra!

Ellers husk å sørge for gjenbruk, reparer i stedet for å kjøpe nytt og resirkuler alt!`,
  },
  microplastics: {
    name: 'Mikroplast',
    header: 'Mikroplast',
    title: 'Hvorfor er mikroplast viktig?',
    stat: {
      title: '9%',
      description:
        'av alt plastavfall som noen gang er produsert har blitt resirkulert',
    },
    didYouKnow: {
      disappearing_plastic: {
        title:
          'Plasten forsvinner ikke fra naturen, selv når den ikke lenger er synlig.',
        secondary_info: {
          title:
            'Plasten forsvinner ikke fra naturen, selv når den ikke lenger er synlig.',
          text: `MARKDOWN:
Plast er et relativt nytt produkt i menneskets historie. Vi vet derfor lite om hva som skjer med plasten over lang tid. Men det er mye forskning som viser at plast stort sett blir i naturen veldig lenge - kanskje evig?

Den brytes opp til mindre og mindre biter fra såkalt “makroplast” til “mikroplast” og til slutt til “nanoplast”. 

Mikroplast er plastbiter på mellom 1 mikrometer til 5 millimeter - nanoplast er enda mindre.`,
        },
      },
      microplastics: {
        title: 'Mikroplast kan til slutt havne i maten du spiser.',
        secondary_info: {
          title: 'Mikroplast kan til slutt havne i maten du spiser.',
          text: `MARKDOWN:
Fugler og dyr er ekstra utsatt for å få i seg mikroplast. Dette fører til at mange dyr og fugler blir syke og i verste fall dør.

Mikroplasten fungerer også som en svamp som tiltrekker seg andre miljøgifter. Dermed spres miljøgifter via mikroplasten, inn i næringskjeder, økosystemer og dyr. Til slutt kan den ende opp på tallerken din hjemme.`,
        },
      },
    },
    statement: {
      avoid_plastic: {
        title: 'Dine handlinger betyr noe',
        secondary_info: {
          title: 'Dine handlinger betyr noe',
          text: `MARKDOWN:
Bildekk er den største utslippskilden til mikroplast i Norge i dag. Derfor er det et stort bidrag å la bilen stå. Ellers er det best å unngå å bruke plast der du kan. 

Du kan kjøpe produkter som ikke inneholder mikroplast og vaske klærne dine sjeldnere. Ikke minst kan du være med på å pushe politikere og næringsliv til å finne bedre alternativer og tiltak for å forhindre mikroplastutslipp.`,
        },
      },
    },
    description: `MARKDOWN:
###Hvorfor er mikroplast viktig?
Plast er et relativt nytt produkt i menneskets historie. Vi vet derfor lite om hva som skjer med plasten over lang tid. Men det er mye forskning som viser at plast stort sett blir i naturen veldig lenge - kanskje evig? 

Plasten forsvinner ikke fra naturen selv om vårt menneskelige øye ikke kan se den lenger. Den brytes opp til mindre og mindre biter fra såkalt “makroplast” til “mikroplast” og til slutt til “nanoplast”. Mikroplast er plastbiter på mellom 1 mikrometer til 5 millimeter - nanoplast er enda mindre. 

Fugler og dyr er ekstra utsatt for å få i seg mikroplast. Dette fører til at mange dyr og fugler blir syke og i verste fall dør.. Mikroplasten fungerer også som en svamp som tiltrekker seg andre miljøgifter. Dermed spres miljøgifter via mikroplasten, inn i næringskjeder, økosystemer og dyr. Til slutt kan den ende opp på tallerken din hjemme.

Så hva kan du gjøre? Bildekk er den største utslippskilden til mikroplast i Norge i dag. Derfor er det et stort bidrag å la bilen stå. Ellers er det best å unngå å bruke plast der du kan. Du kan kjøpe produkter som ikke inneholder mikroplast og vaske klærne dine sjeldnere. Ikke minst kan du være med på å pushe politikere og næringsliv til å finne bedre alternativer og tiltak for å forhindre mikroplastutslipp.`,
  },
  1: {
    name: 'SDG 1',
    header: 'SDG 1',
    title: 'Bærekraftsmål 1',
    description: `MARKDOWN:
###Utrydde fattigdom

**Hovedmål: Utrydde alle former for fattigdom i hele verden**

I 1990 levde 36 prosent av verdens befolkning i ekstrem fattigdom. Siden den gang har andelen ekstremt fattige blitt mer enn halvert. 767 millioner mennesker lever i dag under fattigdomsgrensa på 1,90 dollar dagen. Ekstrem fattigdom skal utryddes innen 2030.

For å bekjempe fattigdom må den økonomiske veksten være inkluderende og fordeles jevnere blant land og befolkning. Den må skape bærekraftige jobber, og gi like muligheter til alle.

_Innholdet er hentet direkte fra [FN-Sambandet](https://www.fn.no/Om-FN/FNs-baerekraftsmaal)_`,
  },
  2: {
    name: 'SDG 2',
    header: 'SDG 2',
    title: 'Bærekraftsmål 2',
    description: `MARKDOWN:
###Utrydde sult

**Hovedmål: Utrydde sult, oppnå matsikkerhet og bedre ernæring, og fremme bærekraftig landbruk**

Selv om antallet mennesker som lever i kronisk sult fortsatt er svært høyt, har andelen sunket fra 23,3 prosent i 1990-92 til 12,9 prosent i 2014-2016. 821 millioner mennesker er rammet av sult, mens nesten 2 milliarder opplever manglende matsikkerhet i perioder.

Det er på tide å tenke nytt om måten vi dyrker, fordeler og bruker maten vår. Hvis vi gjør det på riktig måte, kan jordbruk, skog og fisk sørge for næringsrik mat til alle, og samtidig være en viktig inntektskilde for mange.

_Innholdet er hentet direkte fra [FN-Sambandet](https://www.fn.no/Om-FN/FNs-baerekraftsmaal)_`,
  },
  3: {
    name: 'SDG 3',
    header: 'God helse',
    subheader: 'Bærekraftsmål 3',
    title: 'Bærekraftsmål 3',
    didYouKnow: {
      healthy_lives: {
        title: 'Sikre god helse og fremme livskvalitet for alle, uansett alder',
      },
      urgent_call: {
        title:
          'Målene for bærekraftig utvikling er et rop til verden om å handle',
        text: `MARKDOWN:
De 17 målene skal utrydde fattigdom, beskytte planeten og forbedre livene og framtiden til alle, overalt.

Alle FNs medlemsland vedtok disse målene i 2015, som en del av 2030-agendaen for bærekraftig utvikling.

Ved å koble relevante mål til aktiviteter kan vi bedre forstå de små skrittene vi kan gjøre for å bidra til å nå dem.`,
      },
    },
    description: `MARKDOWN:
###God helse

**Hovedmål: Sikre god helse og fremme livskvalitet for alle, uansett alder**

At alle kan leve friske og sunne liv er en forutsetning for å oppnå bærekraftig utvikling. Det er gjort store framskritt i arbeidet med å øke forventet levealder, og minske mødre- og barnedødelighet i verden.

For at dette bærekraftsmålet skal nås, kreves det likevel en massiv innsats de neste 15 årene. En rekke alvorlige sykdommer må utryddes, og andre store helseutfordringer må håndteres.

_Innholdet er hentet direkte fra [FN-Sambandet](https://www.fn.no/Om-FN/FNs-baerekraftsmaal)_`,
  },
  4: {
    name: 'SDG 4',
    title: 'Bærekraftsmål 4',
    description: `MARKDOWN:
###God utdanning

**Hovedmål: Sikre inkluderende, rettferdig og god utdanning og fremme muligheter for livslang læring for alle**

En god utdanning er grunnlaget for å forbedre menneskers liv. Jenter og gutter skal ha lik tilgang til utdanning med god kvalitet, og den skal være gratis. 

Det har vært en enorm økning i andelen barn i verden som går på skole. Framgangen er spesielt stor når det gjelder jenter og kvinner. Det har også vært en formidabel forbedring i grunnleggende lese- og skriveferdigheter. Likevel er det fortsatt altfor mange som ikke kan lese og skrive.

_Innholdet er hentet direkte fra [FN-Sambandet](https://www.fn.no/Om-FN/FNs-baerekraftsmaal)_`,
  },
  5: {
    name: 'SDG 5',
    title: 'Bærekraftsmål 5',
    description: `MARKDOWN:
###Likestilling mellom kjønnene

**Hovedmål: Oppnå likestilling og styrke jenter og kvinners stilling**

Likestilling er en menneskerett. Det handler om å gi begge kjønn like rettigheter og muligheter til å bestemme over eget liv. Kvinners tilgang til utdanning, helsetjenester, arbeid og juridiske rettigheter er nødvendig for å skape utvikling i et land.

_Innholdet er hentet direkte fra [FN-Sambandet](https://www.fn.no/Om-FN/FNs-baerekraftsmaal)_`,
  },
  6: {
    name: 'SDG 6',
    header: 'Rent vann og gode sanitærforhold',
    subheader: 'Bærekraftsmål 6',
    title: 'Bærekraftsmål 6',
    didYouKnow: {
      water_access: {
        title:
          'Sikre bærekraftig vannforvaltning og tilgang til vann og gode sanitærforhold for alle',
      },
      urgent_call: {
        title:
          'Målene for bærekraftig utvikling er et rop til verden om å handle',
        text: `MARKDOWN:
De 17 målene skal utrydde fattigdom, beskytte planeten og forbedre livene og framtiden til alle, overalt.

Alle FNs medlemsland vedtok disse målene i 2015, som en del av 2030-agendaen for bærekraftig utvikling.

Ved å koble relevante mål til aktiviteter kan vi bedre forstå de små skrittene vi kan gjøre for å bidra til å nå dem.`,
      },
    },
    description: `MARKDOWN:
###Rent vann og gode sanitærforhold

**Hovedmål: Sikre bærekraftig vannforvaltning og tilgang til vann og gode sanitærforhold for alle**

Alle må ha tilgang til rent vann hvis vi skal oppnå bærekraftig utvikling. Det finnes nok ferskvann på planeten, men dårlig økonomi og manglende infrastruktur står ofte i veien.

Det er gjort store framskritt i arbeidet med å sikre tilgang til toaletter for alle. Utviklingen har imidlertid gått for sakte. Millioner av mennesker dør hvert år av sykdommer de får fordi de ikke har tilgang til rent vann og toalett.

_Innholdet er hentet direkte fra [FN-Sambandet](https://www.fn.no/Om-FN/FNs-baerekraftsmaal)_`,
  },
  7: {
    name: 'SDG 7',
    title: 'Bærekraftsmål 7',
    description: `MARKDOWN:
###Ren energi for alle

**Hovedmål: Sikre tilgang til pålitelig, bærekraftig og moderne energi til en overkommelig pris for alle**

Tilgang til energi står i sentrum av så nær som alle utfordringer og muligheter vi møter i dag. Det kan dreie seg om jobber, sikkerhet, klimaendringer, matproduksjon eller muligheter for økt inntekt. 

Energi er den største bidragsyteren til klimaendringer, gjennom utslipp av CO\u2082 og andre klimagasser, Løsningen er fornybar energi som vannkraft, vindkraft og solkraft. Fornybar energi er bærekraftig. 

_Innholdet er hentet direkte fra [FN-Sambandet](https://www.fn.no/Om-FN/FNs-baerekraftsmaal)_`,
  },
  8: {
    name: 'SDG 8',
    header: 'Anstendig arbeid og økonomisk vekst',
    subheader: 'Bærekraftsmål 8',
    title: 'Bærekraftsmål 8',
    didYouKnow: {
      sustainable_growth: {
        title:
          'Fremme varig, inkluderende og bærekraftig økonomisk vekst, full sysselsetting og anstendig arbeid for alle',
      },
      urgent_call: {
        title:
          'Målene for bærekraftig utvikling er et rop til verden om å handle',
        text: `MARKDOWN:
De 17 målene skal utrydde fattigdom, beskytte planeten og forbedre livene og framtiden til alle, overalt.

Alle FNs medlemsland vedtok disse målene i 2015, som en del av 2030-agendaen for bærekraftig utvikling.

Ved å koble relevante mål til aktiviteter kan vi bedre forstå de små skrittene vi kan gjøre for å bidra til å nå dem.`,
      },
    },
    description: `MARKDOWN:
###Anstendig arbeid og økonomisk vekst

**Hovedmål: Fremme varig, inkluderende og bærekraftig økonomisk vekst, full sysselsetting og anstendig arbeid for alle**

Omtrent halvparten av verdens befolkning tjener så dårlig at ikke de kan leve av lønnen sin. Å skape økonomisk vekst og nye arbeidsplasser gjennom anstendig arbeid er en forutsetning for bærekraftig utvikling. Å skape arbeidsplasser av god kvalitet er en av de største utfordringene for alle land fram mot 2030.

_Innholdet er hentet direkte fra [FN-Sambandet](https://www.fn.no/Om-FN/FNs-baerekraftsmaal)_`,
  },
  9: {
    name: 'SDG 9',
    header: 'Innovasjon og infrastruktur',
    subheader: 'Bærekraftsmål 9',
    title: 'Bærekraftsmål 9',
    didYouKnow: {
      resilient_infrastructure: {
        title:
          'Bygge solid infrastruktur, fremme inkluderende og bærekraftig industrialisering og bidra til innovasjon',
      },
      urgent_call: {
        title:
          'Målene for bærekraftig utvikling er et rop til verden om å handle',
        text: `MARKDOWN:
De 17 målene skal utrydde fattigdom, beskytte planeten og forbedre livene og framtiden til alle, overalt.

Alle FNs medlemsland vedtok disse målene i 2015, som en del av 2030-agendaen for bærekraftig utvikling.

Ved å koble relevante mål til aktiviteter kan vi bedre forstå de små skrittene vi kan gjøre for å bidra til å nå dem.`,
      },
    },
    description: `MARKDOWN:
###Innovasjon og infrastruktur

**Hovedmål: Bygge solid infrastruktur, fremme inkluderende og bærekraftig industrialisering og bidra til innovasjon**

Investeringer i transport, vanningssystemer, energi og informasjonsteknologi er helt avgjørende for å skape en bærekraftig utvikling. 

Infrastruktur er den underliggende strukturen som må være på plass for at et samfunn skal fungere.Infrastruktur er en forutsetning for økning i vekst og produktivitet, og for forbedringer i utdannings- og helsetilbud.

Teknologi og innovasjon kan bidra til å løse miljømessige utfordringer som følger utbyggingen av infrastruktur.

_Innholdet er hentet direkte fra [FN-Sambandet](https://www.fn.no/Om-FN/FNs-baerekraftsmaal)_`,
  },
  10: {
    name: 'SDG 10',
    header: 'Mindre ulikhet',
    subheader: 'Bærekraftsmål 10',
    title: 'Bærekraftsmål 10',
    didYouKnow: {
      reduce_inequality: {
        title: 'Redusere ulikhet i og mellom land',
      },
      urgent_call: {
        title:
          'Målene for bærekraftig utvikling er et rop til verden om å handle',
        text: `MARKDOWN:
De 17 målene skal utrydde fattigdom, beskytte planeten og forbedre livene og framtiden til alle, overalt.

Alle FNs medlemsland vedtok disse målene i 2015, som en del av 2030-agendaen for bærekraftig utvikling.

Ved å koble relevante mål til aktiviteter kan vi bedre forstå de små skrittene vi kan gjøre for å bidra til å nå dem.`,
      },
    },
    description: `MARKDOWN:
###Mindre ulikhet

**Hovedmål: Redusere ulikhet i og mellom land**

Økonomisk vekst har bidratt til at flere land har blitt rikere. Dette fører ikke automatisk til mindre fattigdom. Vi må redusere ulikheter mellom land, og innad i land, for å kunne skape en bærekraftig utvikling. 

En rettferdig fordeling av et lands ressurser er nødvendig for å redusere fattigdom og skape stabile samfunn. Samtidig øker forskjellene mellom innbyggerne både i rike og fattige land. Det gjelder både ulikhet i inntekt og formue, og i tilgang til skole, helsehjelp og muligheter.

_Innholdet er hentet direkte fra [FN-Sambandet](https://www.fn.no/Om-FN/FNs-baerekraftsmaal)_`,
  },
  11: {
    name: 'SDG 11',
    header: 'Bærekraftige byer og samfunn',
    subheader: 'Bærekraftsmål 11',
    title: 'Bærekraftsmål 11',
    didYouKnow: {
      inclusive_cities: {
        title:
          'Gjøre byer og bosettinger inkluderende, trygge, motstandsdyktige og bærekraftige',
      },
      urgent_call: {
        title:
          'Målene for bærekraftig utvikling er et rop til verden om å handle',
        text: `MARKDOWN:
De 17 målene skal utrydde fattigdom, beskytte planeten og forbedre livene og framtiden til alle, overalt.

Alle FNs medlemsland vedtok disse målene i 2015, som en del av 2030-agendaen for bærekraftig utvikling.

Ved å koble relevante mål til aktiviteter kan vi bedre forstå de små skrittene vi kan gjøre for å bidra til å nå dem.`,
      },
    },
    description: `MARKDOWN:
###Bærekraftige byer og samfunn

**Hovedmål: Gjøre byer og bosettinger inkluderende, trygge, motstandsdyktige og bærekraftige**

Verden urbaniseres i en fart vi aldri har sett maken til. Mer enn halvparten av verdens befolkning bor i dag i byer, og andelen kommer til å fortsette og øke. Byene fungerer som smeltedigler fulle av ideer, handel, kultur, vitenskap og sosial samhandling. Samtidig står byene for 75 prosent av alle klimagassutslipp og store slumområder hindrer gode levekår. 

Mer enn halvparten av verdens befolkning bor nå i byer. Ytterligere 2.5 milliarder mennesker vil flytte til byer innen 2050. Urbanisering skaper store muligheter og utfordringer. På sitt beste sørger byer for at mennesker kan leve gode liv og utvikle seg både økonomisk og sosialt, men de skaper også miljøproblemer.  

Mange byer vokser fortere enn tilbudet av arbeidsplasser og boliger. Dette fører til utviklingen av slumområder med dårlige boforhold og manglende tjenester til innbyggerne. I årene som kommer vil slumområder huse flesteparten av verdens fattige. 

_Innholdet er hentet direkte fra [FN-Sambandet](https://www.fn.no/Om-FN/FNs-baerekraftsmaal)_`,
  },
  12: {
    name: 'SDG 12',
    header: 'Ansvarlig forbruk og produksjon',
    subheader: 'Bærekraftsmål 12',
    title: 'Bærekraftsmål 12',
    didYouKnow: {
      sustainable_consumption: {
        title: 'Sikre bærekraftig forbruks- og produksjonsmønstre',
      },
      urgent_call: {
        title:
          'Målene for bærekraftig utvikling er et rop til verden om å handle',
        text: `MARKDOWN:
De 17 målene skal utrydde fattigdom, beskytte planeten og forbedre livene og framtiden til alle, overalt.

Alle FNs medlemsland vedtok disse målene i 2015, som en del av 2030-agendaen for bærekraftig utvikling.

Ved å koble relevante mål til aktiviteter kan vi bedre forstå de små skrittene vi kan gjøre for å bidra til å nå dem.`,
      },
    },
    description: `MARKDOWN:
###Ansvarlig forbruk og produksjon

**Hovedmål: Sikre bærekraftig forbruks- og produksjonsmønstre**

Bærekraftig forbruk og produksjon handler om å gjøre mer med mindre ressurser. 

Bærekraftig produksjon innebærer å minske ressursbruk, miljøødeleggelse og klimagassutslipp når en lager en vare. På sikt vil dette føre til økonomisk vekst, begrense klimaendringer og øke livskvaliteten til mennesker på jorda. For å presse bedrifter til å produsere bærekraftig kan staten blant annet innføre lover og avgifter, og investere i miljøvennlig teknologi.  

I dag forbruker vi mer enn hva som er miljømessig bærekraftig. For å sikre gode levekår for nåværende og fremtidige generasjoner må også hver enkelt forbruker endre livsstil.

_Innholdet er hentet direkte fra [FN-Sambandet](https://www.fn.no/Om-FN/FNs-baerekraftsmaal)_`,
  },
  13: {
    name: 'SDG 13',
    header: 'Stoppe klimaendringene',
    subheader: 'Bærekraftsmål 13',
    title: 'Bærekraftsmål 13',
    didYouKnow: {
      urgent_action: {
        title:
          'Handle umiddelbart for å bekjempe klimaendringene og konsekvensene av dem',
      },
      urgent_call: {
        title:
          'Målene for bærekraftig utvikling er et rop til verden om å handle',
        text: `MARKDOWN:
De 17 målene skal utrydde fattigdom, beskytte planeten og forbedre livene og framtiden til alle, overalt.

Alle FNs medlemsland vedtok disse målene i 2015, som en del av 2030-agendaen for bærekraftig utvikling.

Ved å koble relevante mål til aktiviteter kan vi bedre forstå de små skrittene vi kan gjøre for å bidra til å nå dem.`,
      },
    },
    description: `MARKDOWN:
###Stoppe klimaendringene

**Hovedmål: Handle umiddelbart for å bekjempe klimaendringene og konsekvensene av dem**

Klimaendringer er et globalt spørsmål og kjenner ingen landegrenser. Derfor må vi også finne globale løsninger. I tillegg til å kutte i utslipp og fange og lagre CO\u2082, må det satses langt mer på fornybar energi og annen ren energi. 

Forskerne i FNs klimapanel mener at to graders temperaturøkning er grensen for hva naturen kan tåle. Stiger temperaturen mer enn det vil klimaendringene bli ukontrollerbare. På klimatoppmøtet i Paris i 2015 ble verdens ledere derfor enige om en ny avtale. Der forplikter landene seg til å gjøre alt de kan for at temperaturen ikke skal stige mer enn to grader, og helst ikke mer enn 1,5..

_Innholdet er hentet direkte fra [FN-Sambandet](https://www.fn.no/Om-FN/FNs-baerekraftsmaal)_`,
  },
  14: {
    name: 'SDG 14',
    header: 'Liv under vann',
    subheader: 'Bærekraftsmål 14',
    title: 'Bærekraftsmål 14',
    didYouKnow: {
      conserve_oceans: {
        title:
          'Bevare og bruke hav og marine ressurser på en måte som fremmer bærekraftig utvikling',
      },
      urgent_call: {
        title:
          'Målene for bærekraftig utvikling er et rop til verden om å handle',
        text: `MARKDOWN:
De 17 målene skal utrydde fattigdom, beskytte planeten og forbedre livene og framtiden til alle, overalt.

Alle FNs medlemsland vedtok disse målene i 2015, som en del av 2030-agendaen for bærekraftig utvikling.

Ved å koble relevante mål til aktiviteter kan vi bedre forstå de små skrittene vi kan gjøre for å bidra til å nå dem.`,
      },
    },
    description: `MARKDOWN:
###Liv under vann

**Hovedmål: Bevare og bruke hav og marine ressurser på en måte som fremmer bærekraftig utvikling**

Det er verdenshavene – deres temperatur, kjemi, strømninger og liv – som driver de globale systemene som gjør det mulig for mennesker å leve på jorda.  Regn, drikkevann, været, klimaet, mye av maten vår og til og med lufta vi puster inn er til syvende og sist regulert av havet.

Marine næringer er viktige for å dekke økende etterspørsel etter mat, energi og medisin i framtiden. Slik byr havet også på muligheter for nye arbeidsplasser og økonomisk vekst. 

_Innholdet er hentet direkte fra [FN-Sambandet](https://www.fn.no/Om-FN/FNs-baerekraftsmaal)_`,
  },
  15: {
    name: 'SDG 15',
    header: 'Liv på land',
    subheader: 'Bærekraftsmål 15',
    title: 'Bærekraftsmål 15',
    didYouKnow: {
      sustainable_management: {
        title:
          'Beskytte, gjenopprette og fremme bærekraftig bruk av økosystemer, sikre bærekraftig skogforvaltning, bekjempe ørkenspredning, stanse og reversere landforringelse samt stanse tap av artsmangfold',
      },
      urgent_call: {
        title:
          'Målene for bærekraftig utvikling er et rop til verden om å handle',
        text: `MARKDOWN:
De 17 målene skal utrydde fattigdom, beskytte planeten og forbedre livene og framtiden til alle, overalt.

Alle FNs medlemsland vedtok disse målene i 2015, som en del av 2030-agendaen for bærekraftig utvikling.

Ved å koble relevante mål til aktiviteter kan vi bedre forstå de små skrittene vi kan gjøre for å bidra til å nå dem.`,
      },
    },
    description: `MARKDOWN:
###Liv på land

**Hovedmål: Beskytte, gjenopprette og fremme bærekraftig bruk av økosystemer, sikre bærekraftig skogforvaltning, bekjempe ørkenspredning, stanse og reversere landforringelse samt stanse tap av artsmangfold**

Skog dekker 30 prosent av jordas overflate. Skogen gir mat og ly, bekjemper klimaendringer, tar vare på det biologiske mangfoldet, og er hjemmet til mange urfolk. Over 80 prosent av alle dyr, planter og insekter som lever på land, bor i skogen. 1,6 milliarder mennesker har skogen som sitt levebrød. Avskoging og ørkenspredning er store utfordringer når det gjelder å skape bærekraftig utvikling. Samtidig gjør de menneskene som er avhengige av skogen mer utsatt for fattigdom.

2,6 milliarder mennesker får sin inntekt direkte fra jordbruk, men over 50 prosent av alt land som brukes til dyrking er utsatt for en degradering av jordsmonnet.

_Innholdet er hentet direkte fra [FN-Sambandet](https://www.fn.no/Om-FN/FNs-baerekraftsmaal)_`,
  },
  16: {
    name: 'SDG 16',
    title: 'Bærekraftsmål 16',
    description: `MARKDOWN:
###Fred og rettferdighet

**Hovedmål: Fremme fredelige og inkluderende samfunn med sikte på bærekraftig utvikling, sørge for tilgang til rettsvern for alle og bygge velfungerende, ansvarlige og inkluderende institusjoner på alle nivåer**

Å sikre internasjonal fred og sikkerhet har alltid vært FNs hovedoppgave. Derfor er mål 16 viet til å skape fredelige og inkluderende samfunn.Fred er en forutsetning for å skape bærekraftig utvikling. Under konflikter mister mange tilgang til offentlige tjenester. I tillegg er det vanskelig å drive sterke statlige institusjoner under en konflikt. Når for eksempel rettsvesenet i et land fungerer dårlig, går det ut over menneskers rettssikkerhet. Svake institusjoner gjør det også vanskeligere å stoppe korrupsjon, bestikkelser og skatteunndragelser. Dette hemmer den økonomiske veksten i et land og frarøver mennesker retten til grunnleggende velferdstjenester. 

_Innholdet er hentet direkte fra [FN-Sambandet](https://www.fn.no/Om-FN/FNs-baerekraftsmaal)_`,
  },
  17: {
    name: 'SDG 17',
    title: 'Bærekraftsmål 17',
    description: `MARKDOWN:
###Samarbeid for å nå målene

**Hovedmål: Styrke gjennomføringsmidlene og fornye globale partnerskap for bærekraftig utvikling**

For å lykkes med bærekraftsmålene trengs det nye og sterke partnerskap. Myndigheter, næringslivet og sivilsamfunnet må samarbeide for å oppnå bærekraftig utvikling. Bærekraftsmålene skal fungere som en felles, global retning og prioritert innsats de neste 15 årene. Erfaring fra Tusenårsmålene viser at denne typen målrettet innsats virker.

Finansiering av målene må på plass raskt. Juli 2015 ble landene i FN enige om en felles finansieringsplan for målene, på konferansen Financing for Development i Addis Ababa, Etiopia.

_Innholdet er hentet direkte fra [FN-Sambandet](https://www.fn.no/Om-FN/FNs-baerekraftsmaal)_`,
  },
};
